import * as yup from 'yup';

// Either define validations for each field and export them alone
// or you can define a group of validations and export them together like this
// Defining validations as a group might be good if it is done for an entire form
const testValidations = {
  name: yup.string().required('Name is required.'),
  email: yup.string().required('Email is required.').email('Invalid email address.'),
  password: yup
    .string()
    .required('Password is required.')
    .min(8, 'Password must be at least 8 characters.')
    .matches(/[a-z]/, 'Must contain at least one lowercase letter.')
    .matches(/[A-Z]/, 'Must contain at least one uppercase letter.')
    .matches(/[0-9]/, 'Must contain at least one number.')
    .matches(/[!@#$%^&*]/, 'Must contain at least one special character.'),

  role: yup.object().required('Role is required.'),
  phoneNumber: yup
    .string()
    .required('Phone number is required.')
    .matches(/^\+?[1-9]\d{7}$/, 'Please enter a valid phone number with a minimum of 7 digits.'),
  date: yup
    .date()
    .required('Date is required.')
    .min(new Date(1900, 0, 1), 'Date must be later than January 1st, 1900.')
    .max(new Date(), 'Date cannot be in the future.'),
  agree: yup.boolean().required('Checkbox is required.').oneOf([true], 'Agree to continue.'),
  fileInput: yup
    .array()
    .of(
      yup
        .mixed()
        .test('required', 'Please select a file.', (value) => value)
        .test(
          'fileSize',
          'File too large.',
          (value) => value.size <= 10 * 1024 * 1024 // 10MB limit
        )
        .test('fileType', 'Unsupported file type.', (value) => {
          const validTypes = [
            'image/jpeg',
            'image/png',
            'video/mp4',
            'video/mov',
            'video/webm',
            'video/avi',
            'audio/mpeg',
            'audio/mp3',
            'application/pdf',
          ];
          return validTypes.includes(value.type);
        })
    )
    .min(1, 'At least one file is required.')
    .max(10, 'Maximum 10 files are allowed.'),
};

export default testValidations;
